import { FulfilmentType } from 'config';
import t from 'lib/i18n';
import "styles/components/delivery-option.scss";

import Button, { ButtonTypes, ButtonVariants } from "components/ui/Button";
import { ReactComponent as ETicketIcon } from "static/images/delivery/eticket.svg";
import { ReactComponent as PrintAtHomeIcon } from "static/images/delivery/print.svg";
import { ReactComponent as CollectionIcon } from "static/images/delivery/collection.svg";
import { ReactComponent as PostalIcon } from "static/images/delivery/postal.svg";
import { ReactComponent as SmartcardIcon } from "static/images/delivery/smartcard.svg";

const DeliveryOptionIcon = ({ fulfilmentMethod }) => {
  const className = "otrl-jp__delivery-option-input__icon";
  
  switch (fulfilmentMethod) {
    case FulfilmentType.E_TICKET:
      return <ETicketIcon className={className} />;
    case FulfilmentType.PRINT_AT_HOME:
      return <PrintAtHomeIcon className={className} />;
    case FulfilmentType.COLLECTION:
      return <CollectionIcon className={className} />;
    case FulfilmentType.POSTAL:
      return <PostalIcon className={className} />;
    case FulfilmentType.SMARTCARD:
      return <SmartcardIcon className={className} />;
    default:
      return null;
  }
};

const DeliveryOption = ({ delivery, onChange }) => {  
  const { fulfilmentMethod, price } = delivery;

  const displayName = fulfilmentMethod === FulfilmentType.SMARTCARD
    ? 'Key Smartcard'
    : delivery.displayName;

  const cost = price
    ? new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(price/100)
    : "Free";

  return (
    <div className="otrl-jp__delivery-option-container">
      <div className="otrl-jp__delivery-option">
        <div className="otrl-jp__delivery-option-input" aria-label="Delivery option">
          <div className="otrl-jp__delivery-option-input__container">
            <DeliveryOptionIcon fulfilmentMethod={fulfilmentMethod} />
            <div className="otrl-jp__delivery-option-input__input">
              <span className="otrl-jp__delivery-option-input__method">{displayName}</span>
              <div className="otrl-jp__delivery-option-input__second-row">
                <span className="otrl-jp__delivery-option-input__cost">{cost}</span>
              </div>
            </div>
            <div className="otrl-jp__delivery-option-input__actions">
              <Button
                onClick={onChange}
                textUnderline={true}
                type={ButtonTypes.SUBMIT}
                variant={ButtonVariants.TEXT}
              >
                {t('favourites.form.delivery.change.button')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryOption;